import type { FilterChipOption } from "@/ui/tables/FilterChips";

export type StockStatus = "critical" | "low" | "out";

export type StockFilter = "all" | StockStatus;

export const STOCK_FILTERS: FilterChipOption<StockFilter>[] = [
  { value: "all", label: "Todos" },
  { value: "critical", label: "Stock crítico", dotColor: "red.600" },
  { value: "low", label: "Por alcanzar mínimo", dotColor: "orange.500" },
  { value: "out", label: "Sin stock", dotColor: "gray.400" },
];
